import { render, staticRenderFns } from "./GreenDetail.vue?vue&type=template&id=5067bff0&scoped=true&"
import script from "./GreenDetail.vue?vue&type=script&lang=js&"
export * from "./GreenDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067bff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5067bff0')) {
      api.createRecord('5067bff0', component.options)
    } else {
      api.reload('5067bff0', component.options)
    }
    module.hot.accept("./GreenDetail.vue?vue&type=template&id=5067bff0&scoped=true&", function () {
      api.rerender('5067bff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/GreenDetail.vue"
export default component.exports